import { FormatEditor } from "@/components/FormatEditor";

const PLACEHOLDERS = ["company_name", "bill_no", "bill_date", "customer_name", "loan_type", "lender_name", "items_rows", "subtotal", "tax_total", "grand_total", "notes"];

export default function BillFormat() {
  return (
    <FormatEditor
      title="Bill Format"
      desc="Edit the HTML template used when a bill/invoice is generated and printed."
      endpoint="/settings/bill-format"
      placeholders={PLACEHOLDERS}
      testId="bill-format-page"
    />
  );
}
